<template>
	<div class="myrecords">
		<vs-table ref="table"    :max-items="10"  :data="culturelist">
		  <template slot="thead">
		    <vs-th >序号</vs-th>
		    <vs-th >名称</vs-th>
			<vs-th >姓名</vs-th>
		    <vs-th >备注</vs-th>
			<vs-th >创建时间</vs-th>
			<vs-th >提交时间</vs-th>
			<vs-th >总分</vs-th>
			<vs-th >最终得分</vs-th>
			<vs-th >状态</vs-th>
			<vs-th >操作</vs-th>
		  </template>
		    <template slot-scope="{data}">
		      <tbody>
		        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
		          <vs-td>
		            <p class="product-name font-medium">{{ indextr+1 }}</p>
		          </vs-td>
		          <vs-td>
		            <p class="product-category">{{ tr.name }}</p>
		          </vs-td>
				  <vs-td>
				    <p class="product-category">{{ tr.userName }}</p>
				  </vs-td>
		          <vs-td>
		            <p class="product-price">{{ tr.remarks }}</p>
		          </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.assessTime }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.updateTime?tr.updateTime:'------' }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.totalScore }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.finalScore||"待评分" }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price" :class="tr.status==11?'text-danger':tr.status==2?'text-primary':'text-success'" >{{ tr.status==11?"已抽检":tr.status==2?"已提交":"已完成" }}</p>
				  </vs-td>
				  <vs-td>
				    <vs-button class="mr-4" color="primary" type="filled" @click="details(tr,tr.status)"  size="small">详情</vs-button>
					<vs-button color="success" type="filled" @click="exportexcel(tr.id)"  size="small">导出Excel</vs-button>
				  </vs-td>
				  <template class="expand-user" slot="expand">
				    <div class="con-expand-users w-full p-4">
				        <el-descriptions v-for="(item,index) in tr.reviewerTotalScore" :key="index" border :column="1" class="mb-4" labelClassName="expandlabel">
				            <el-descriptions-item label="审核员">{{item.name}}</el-descriptions-item>
				            <el-descriptions-item label="审核时间">{{item.createTime}}</el-descriptions-item>
				            <el-descriptions-item label="总评语">{{item.remarks}}</el-descriptions-item>
				            <el-descriptions-item label="评分">
				              <el-tag size="small">{{item.totalScore}}</el-tag>
				            </el-descriptions-item>
				        </el-descriptions>
				    </div>
				  </template>
		        </vs-tr>
		      </tbody>
		    </template>
		</vs-table>
		<vs-pagination class="mt-4" :total="total" v-model="itemsPerPage" ></vs-pagination>
	</div>
</template>
<script>
	export default {
	    data() {
	        return {
				culturelist: [],
				total:0,
				itemsPerPage:1,
			}
	    },
		mounted() {
			this.getlist();
		},
		watch: {
		    itemsPerPage:'getlist'
		}, 
		methods:{
			getlist(){    //获取列表
					 const thisIns = this;
					 this.$api.stafflist({pageNum:thisIns.itemsPerPage,pageSize:10,status:"2,10,11"}).then(function (response) {
					 	console.log("列表数据：",response);
					 	if(response.code==0){
					 		 thisIns.culturelist=response.data.data;
					 		 thisIns.total=response.data.pages;
					 	}else{
					 		thisIns.$vs.notify({
					 			  title:"提示",
					 			  color:'warning',
					 			  text:response.message,
					 			  position:'top-center'
					 		});
					 	}
					   }) 
			},
			details(item,status){  //详情
			    localStorage.setItem("userdetails",JSON.stringify(item));
				this.$router.push({path:'/user/myrecorddetails',query:{id:item.id,status:status}})
			},
			exportexcel(id){
				let token = localStorage.getItem('token');
				window.open(`${this.$baseURL}/staffAssess/conserve?id=${id}&authorization=${token}`);
			},
			
		},
	}
</script>
<style type="text/css">
	.expandlabel{
		width: 200px;
	}
</style>
